export default {
  ALARM_DATA: null,
  IS_MEMBER: false,
  SHOW_BELL: false,
  BELL_COUNT: 0,
}
